import React, {Component} from "react";
import {getResultLive} from "../../../redux/actions/result";
import {connect} from "react-redux";
import SportIcon from "../../../components/SportIcon";
import {Link} from "react-router-dom";
import League from "./modules/League";
import Event from "./modules/Event";
import Loading from "../../../components/Loading";

class ResultLiveContainer extends Component {
	intervalId = 0;

	constructor(props) {
		super(props);
		this.loadData = this.loadData.bind(this);
	}

	componentWillMount() {
		this.props.onGetResultLive();
		this.intervalId = setInterval(this.loadData, 5000);

		if (this.props.resultLive.events.length === 0) {
			this.loadData();
		}
	}

	loadData() {
		this.props.onGetResultLive();
	}

	componentWillUnmount() {
		clearInterval(this.intervalId);
	}

	render() {
		const {events, leagues, sports, fetching} = this.props.resultLive;

		const data = sports.map((sport, index) =>
			<div key={`live-event-data-${index}`} className="live-event-data">
				<div className="events__header">
					<div className="events__header__sportname">
						<span className="sport-icon small green events__header__sporticon">
							<SportIcon sportId={sport.id}/>
						</span>
						<span>&nbsp;<Link to={`/live-sport/${sport.id}`}>{sport.name}</Link></span>
					</div>
				</div>
				<div className="events">
					<div className="events__table table-div">
						{leagues.filter((league) => {return league.sportId === sport.id}).map((league) =>
							<League league={league}>
								{events.filter((event) => {return event.leagueId === league.id}).map((event) => <Event event={event}/>)}
							</League>
						)}
					</div>
				</div>
			</div>
		);

		return (
			<div className="body__container__side-right result-live">
				<div className="live-event-header result-live__header">
					<div className="no-dot">Результаты LIVE</div>
				</div>
				{fetching && <Loading/>}
				{data}
			</div>
		);
	}
}

export default connect(
	state => ({
		resultLive : state.result.live
	}),
	dispatch => ({
		onGetResultLive : () => {
			dispatch(getResultLive());
		}
	})
)(ResultLiveContainer);


// WEBPACK FOOTER //
// ./src/app/pages/Result/Live/ResultLiveContainer.js